/* This file is autogenerated, see readme.md for instructions */
import SaveSvgIcon from '@bloomreach/banana-theme/icons/save.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const SaveIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <SaveSvgIcon />
    </Icon>
  );
});

SaveIcon.displayName = 'SaveIcon';

export default SaveIcon;
